/**
 * [API] create axios
 * @module @apis/common/create-axios
 */

import { CloudAxiosIntercepter } from '@/user/apis/common/axios-intercepter'
import axios from 'axios'

const axiosInstance = axios.create({
  withCredentials: true,
  timeout: 60000,
  showLoader: true,
})

axiosInstance.interceptors.request.use(
  (request) => CloudAxiosIntercepter.requestHandler(request),
  (error) => CloudAxiosIntercepter.defaultErrorHandler(error)
)

axiosInstance.interceptors.response.use(
  (response) => CloudAxiosIntercepter.responseHandler(response),
  (error) => CloudAxiosIntercepter.defaultErrorHandler(error)
)

export default axiosInstance
